import React, { useEffect, useState } from 'react';
import sdgs from '../data/sdgs.json'; // Import SDGs data
import { SDGTransformed, UserSDG } from 'sdgselection/types/SDG';
import '../styles/sdg-selection.css'; // Import the CSS file
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSubtract, faTrash } from '@fortawesome/free-solid-svg-icons';
import useAuthUserId from 'auth/hooks/useAuthUser';
import userSdgApi from '../utils/API';
import { LoaderPrimary } from 'common/components/Loader/Loader';
import { Link } from 'react-router-dom';
import { pageNames } from 'config/pageNames';
import UserSdgList from './UserSdgList';

const sdgList: SDGTransformed[] = sdgs as unknown as SDGTransformed[];

const SDGSelected = () => {
  const [selectedSDGs, setSelectedSDGs] = useState<number[]>([]);
  const [userSdg, setUserSdg] = useState<UserSDG | null>(null);
  const [userSdgs, setUserSdgs] = useState<UserSDG[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const userId = useAuthUserId();

  const handleDelete = async (_id: string) =>{
    setIsLoading(true);
    try{
        const response = await userSdgApi.DeleteUserSdg(_id);
        if(response){
            const filteredUserSdgs = userSdgs?.filter(sdg => sdg._id !== _id);
            setUserSdgs([...(filteredUserSdgs || [])]);
        }
        setIsLoading(false);
    }
    catch(e){
        setIsLoading(false);
    }    
  }  

  const fetchUserSdgs = async (userId: string) =>{
    setIsLoading(true);
    try{
        const response = await userSdgApi.getSdgsByUser(userId);
       
        if(response){
            setUserSdgs(response.userSdgs);
        }
        setIsLoading(false);
    }
    catch(e){
        setIsLoading(false);
    }
  }
  
  useEffect(() => {
    if(userId){
        fetchUserSdgs(userId);
    }
  },[userId]);

  return (
    <div className="sdg-selection">
        
        {isLoading && <LoaderPrimary />}
        <div className="d-flex justify-content-center mt-3 gap-2 mb-3">
            <Link 
                to={pageNames.SDG_SELECTOR} 
                className={`btn ${userSdg?"btn-outline-warning":"btn-outline-primary"} py-3 px-4`}
            >
              {userSdg? 
                "Perform another identification of your sustainability focus"
                : "Start identifying your sustainability focus"
              } 
              <FontAwesomeIcon icon={faSubtract} />
            </Link>
        </div>
        <UserSdgList 
          onDeleteItem={handleDelete} 
          isLoading={false} 
          list={userSdgs}
        />          
        
    </div>
  );
};

export default SDGSelected;
